export const PATH_LOGIN = 'login';
export const PATH_CHANGE_PASSWORD = 'cambiar-contrasena';
export const PATH_LANDING = 'inicio';
export const PATH_LANDING_FIXED = 'inicio-fixed';
export const PATH_DASHBOARD = 'dashboard';
export const PATH_DEVICES = 'devices';
export const PATH_CATEGORIES = 'categories';
export const PATH_PLAYLIST = 'playlists';
export const PATH_MEDIA = 'media';
export const PATH_SUCURSALES = 'sucursales';
export const PATH_USERS = 'users';
export const PATH_VIDEO_WALL = 'video-wall';
export const PATH_OVERLAY_TEXT = 'overlay-text';
export const PATH_OVERLAY_TEXT_EDITOR = 'editor';
export const PATH_EDITOR = 'editor';
export const PATH_VARIANTS = 'variantes';
export const PATH_REGISTER_DEVICES = 'register-devices';
export const PATH_SSO_CALLBACK = 'sso-callback';
export const PATH_AUTH = 'auth';
export const PATH_EMPRESAS = 'empresas';
